import { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { useExamplePreview } from 'hooks/useExamplePreview';

import { GLOBAL_PERIOD_NAME } from 'components/BusinessToolForm/Sections/Global/form';

import { concatWithDot } from 'helpers/string';

import { ICurrentLiabilitiesTableProps } from './types';
import { ProjectedBalanceFieldTable } from '../../../../components/ProjectedBalanceFieldTable';
import { FIRST_COLUMN_WIDTH, liabilitiesAndEquityPrefix } from '../../../../utils/form';
import {
  CURRENT_LIABILITIES_TABLE_NAMES,
  LIABILITIES_AND_EQUITY_FORM_NAMES,
  useGetLiabilityAndEquityTableHeadings,
} from '../../utils/form';

export const CurrentLiabilitiesTable: FC<ICurrentLiabilitiesTableProps> = ({ disabled = false }) => {
  const period = useWatch({ name: GLOBAL_PERIOD_NAME });
  const { isExamplePage} = useExamplePreview()

  const { getValues } = useFormContext();
  const { currentLiabilitiesVariants, currentLiabilitiesTotalRowTitle } = useGetLiabilityAndEquityTableHeadings(isExamplePage);

  const tableName = concatWithDot(
    liabilitiesAndEquityPrefix,
    LIABILITIES_AND_EQUITY_FORM_NAMES.CURRENT_LIABILITIES_TABLE,
  );

  const totalName = concatWithDot(
    liabilitiesAndEquityPrefix,
    LIABILITIES_AND_EQUITY_FORM_NAMES.CURRENT_LIABILITIES_TABLE_TOTAL,
  );

  const totalValues = getValues(totalName);
  const fields = getValues([
    concatWithDot(tableName, CURRENT_LIABILITIES_TABLE_NAMES.ACCOUNTS_PAYABLE),
    concatWithDot(tableName, CURRENT_LIABILITIES_TABLE_NAMES.SHORT_TERM_DEBT),
    concatWithDot(tableName, CURRENT_LIABILITIES_TABLE_NAMES.CURRENT_PORTION_OF_LONG_TERM_DEBT),
    concatWithDot(tableName, CURRENT_LIABILITIES_TABLE_NAMES.ACCRUED_LIABILITIES),
    concatWithDot(tableName, CURRENT_LIABILITIES_TABLE_NAMES.DEFERRED_REVENUE),
    concatWithDot(tableName, CURRENT_LIABILITIES_TABLE_NAMES.DEFERRED_TAX_LIABILITIES),
    concatWithDot(tableName, CURRENT_LIABILITIES_TABLE_NAMES.PROVISIONS),
    concatWithDot(tableName, CURRENT_LIABILITIES_TABLE_NAMES.OTHER_CURRENT_LIABILITIES),
  ]);

  return (
    <ProjectedBalanceFieldTable
      disabled={disabled}
      firstColumnWidth={FIRST_COLUMN_WIDTH}
      name={tableName}
      rows={fields}
      rowTitles={currentLiabilitiesVariants}
      totalRowTitle={currentLiabilitiesTotalRowTitle}
      totalName={totalName}
      period={period}
      totalValues={totalValues}
    />
  );
};
